import Input from './Input';
import { useState } from 'react';
import { Control } from 'react-hook-form';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';

interface Props extends Omit<TextFieldProps, 'name'> {
  name: string;
  control: Control<any>;
}

export default function PasswordInput({ name, control, ...rest }: Props) {
  const [showPassword, setShowPassword] = useState(false);
  const toggleVisibility = () => setShowPassword((prev) => !prev);
  return (
    <Input
      name={name}
      control={control}
      type={showPassword ? 'text' : 'password'}
      {...rest}
      InputProps={{
        ...(rest.InputProps || {}),
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton onClick={toggleVisibility} edge='end'>
              {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
}
